import React, { useEffect, useState } from "react";
import axios from "axios";
import { AESEncryption, ApiResDecrypt, errData } from "../../../CommonMethhods/CommonMethods";

function PreviousObjectionList(props) {
  const { URL } = props;
  const storeToken = localStorage.getItem("ssoToken");
  if (storeToken == null) {
    window.location.replace("/");
  }
  const [prevObj, setPrevObj] = useState([]);
  const [objectionTable, setObjectionTable] = useState(false);
  const [objError, setObjError] = useState("");

  const previousObjection = async () => {
    try {
      const encResponse = await axios.post(
        `${URL}`,
        AESEncryption({
          panNo: localStorage.getItem("panNo"),
        }),

        {
          headers: {
            "content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv:1
          },
        }
      );
      let response = ApiResDecrypt(encResponse.data);
      const data = await response;
      if (data.status == 0) {
        setPrevObj(data.data);
        setObjectionTable(true);
      } else {
        setPrevObj([]);
        setObjectionTable(false);
        setObjError(data.message);
      }
   
    } catch (err) {
      setObjError("Something Went Wrong");
    }
  };

  const showTableData = (prevObj) => {
    if (prevObj.length > 0) {
      return prevObj.map((item, key) => {
        return (
          <tr key={key}>
            <td className="text-center">
              {item.date.split("T")[0] === "" || undefined || null
                ? "-"
                : item.date.split("T")[0]}
            </td>
            <td>
              {item.reason === "" || undefined || null ? "-" : item.reason}
            </td>
            <td>
              {item.rejectedBy === "" || undefined || null
                ? "-"
                : item.rejectedBy}
            </td>
          </tr>
        );
      });
    }
  };
  useEffect(() => {
    previousObjection();
  }, []);

  return (
    <>
      <div className="card-box">
        <div className="section-title-oms card-title">
          <h2 className="objection-title mt-4">Previous Objections</h2>
        </div>
        {objectionTable ? (
          <>
            <div className="for-grid-section">
              <div className="table-responsive scroll-table report-table-wrapper">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col" className="text-center">
                        Date
                      </th>
                      <th scope="col" className="text-center">
                        Reason
                      </th>
                      <th scope="col" className="text-center">
                        Rejected By
                      </th>
                    </tr>
                  </thead>
                  <tbody>{showTableData(prevObj)}</tbody>
                </table>
              </div>
            </div>
          </>
        ) : (
          <>
            {/* {objError} */}
            {/* <div className="rm-maping-no-data">{objError}</div> */}
            {objError !== "" && errData(objError)}
          </>
        )}
      </div>
    </>
  );
}
export default PreviousObjectionList;
